export const BACKGROUND_COLOR = '#ebebf0'